import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './BurgerMenu.module.css';

const BurgerMenu = ({showBurgerMenu, toggleBurgerMenu}) => {
  return (
    <div className={styles.burgerMenuContainer}>
      {showBurgerMenu ? (
        <ul className={styles.navList}>
        <li><NavLink
          to="/"
          exact
          className={styles.navLi}
          activeClassName={styles.navLiActive}
          onClick={toggleBurgerMenu}>Početna</NavLink></li>
        <li><NavLink
          to="/oglasi"
          className={styles.navLi}
          activeClassName={styles.navLiActive}
          onClick={toggleBurgerMenu}>Oglasi</NavLink></li>
        {/*<li><NavLink
          to="/raspored"
          className={styles.navLi}
          activeClassName={styles.navLiActive}
        onClick={toggleBurgerMenu}>Raspored nastave</NavLink></li>*/}
        <li><NavLink
          to="/zavrsni-radovi"
          className={styles.navLi}
          activeClassName={styles.navLiActive}
          onClick={toggleBurgerMenu}>Završni radovi</NavLink></li>
      </ul>
      ) : (
          null
        )}
    </div>
  );
}

export default BurgerMenu;